import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { ProductCreationView } from "./view";
import { ColumnsActionsFlags, ColumnsPaymentMode, ColumnsPaymentRecurrence, ColumnsPlans, dataForm, dataProductCreationForm, } from "./productCreationsDTO";
import { GetInsurancesTypes } from "../../../fnx/insurances/getInsurancesTypes";
import { useDispatch, useSelector } from "react-redux";
import LocalStorageService from "../../../services/localStorage";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { sponsor } from "../../../store/sponsor/actions";
import { projectOneClearData, projectPatch, projectPatchClearData, projectPost, projectPostClearData, } from "../../../store/project/actions";
import { campaignOneClearData, campaignPatch, campaignPatchClearData, campaignPost, campaignPostClearData, } from "../../../store/campaign/actions";
import { showErrorToast } from "../../../fnx/showError";
import showToast from "../../../services/toast";
import { themeCore } from "../../../assets/themes/theme";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { useNavigate, useParams } from "react-router-dom";
import { paymentModeAction, paymentModeClearData, postPaymentMode, postPaymentModeClearData, } from "../../../store/paymentModes/action";
import { GetCatalogPaymentMode } from "../../../fnx/catalog/getCatalogPaymentMode";
import { GetCatalogAccountType } from "../../../fnx/catalog/getCatalogAccountType";
import { accountType, accountTypeClearData, accountTypePost, accountTypePostClearData, } from "../../../store/accountType/actions";
import { campaignProjectPost, campaignProjectPostClearData, } from "../../../store/campaignProject/actions";
import { useTranslation } from "react-i18next";
import { GetProjectOne } from "../../../fnx/project/projectOne";
import { getCatalogAccountTypeClearData, getCatalogPaymentModeClearData, } from "../../../store/catalog/actions";
import { GetCampaignOne } from "../../../fnx/campaign/getCampaignOne";
import { formattedDateYYMMDD } from "../../../utils/date";
import { GetCurrencies } from "../../../fnx/currencies/currencies";
import { useGetPlansAll } from "../../../fnx/plans/plansGetAll";
import { plansClearData } from "../../../store/plans/actions";
import { GetActionFlags } from "../../../fnx/actionsFlags/getActionFlags";
import { deleteEntity, deleteEntityClearData, } from "../../../store/delete/actions";
import { PostActionFlags } from "../../../fnx/actionsFlags/postActionFlags";
import { clearDataPutAvatar, putAvatar } from "../../../store/avatar/actions";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ProductCreation = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    var plans = useParams().plans;
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var limit = React.useState(1000)[0];
    var orderBy = React.useState("name")[0];
    var orderDir = React.useState("ASC")[0];
    var _c = useState(false), trigger = _c[0], setTrigger = _c[1];
    var _d = useState(false), triggerActionF = _d[0], setTriggerActionF = _d[1];
    var _e = useState(false), triggerPlans = _e[0], setTriggerPlans = _e[1];
    var _f = useState(false), triggerDetails = _f[0], setTriggerDetails = _f[1];
    var _g = useState(false), triggerCampaign = _g[0], setTriggerCampaign = _g[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _h = React.useState(true), disableCampaign = _h[0], setDisableCampaign = _h[1];
    var _j = React.useState(true), disableRecurrence = _j[0], setDisableRecurrence = _j[1];
    var _k = React.useState(true), disablePaymentMode = _k[0], setDisablePaymentMode = _k[1];
    var _l = React.useState(true), disablePlans = _l[0], setDisablePlans = _l[1];
    var _m = React.useState(true), disableFlags = _m[0], setDisableFlags = _m[1];
    var _o = React.useState(true), activateEditProduct = _o[0], setActivateEditProduct = _o[1];
    var _p = React.useState(true), activateEditCampaign = _p[0], setActivateEditCampaign = _p[1];
    var _q = React.useState(false), showCancelButton = _q[0], setShowCancelButton = _q[1];
    var _r = React.useState(true), showAddButtonRecurrence = _r[0], setShowAddButtonRecurrence = _r[1];
    var _s = React.useState(true), showAddButtonPaymentMode = _s[0], setShowAddButtonPaymentMode = _s[1];
    var _t = React.useState(true), showAddButtonPlans = _t[0], setShowAddButtonPlans = _t[1];
    var _u = React.useState(true), showButtonsActions = _u[0], setShowButtonsActions = _u[1];
    var _v = React.useState(true), showButtonAddCampaign = _v[0], setShowButtonAddCampaign = _v[1];
    var _w = React.useState(false), openModal = _w[0], setOpenModal = _w[1];
    var _x = React.useState([]), insuranceTypeList = _x[0], setInsuranceTypeList = _x[1];
    var _y = React.useState([]), sponsorList = _y[0], setSponsorList = _y[1];
    var _z = React.useState([]), currencyList = _z[0], setCurrencyList = _z[1];
    var _0 = React.useState([]), paymentModeList = _0[0], setPaymentModeList = _0[1];
    var _1 = React.useState([]), accountTypeList = _1[0], setAccountTypeList = _1[1];
    var _2 = useState(dataProductCreationForm), dataProductCreation = _2[0], setDataProductCreation = _2[1];
    var _3 = useState(dataForm), dataCampaignCreation = _3[0], setDataCampaignCreation = _3[1];
    var _4 = useState(false), isUpdate = _4[0], setIsUpdate = _4[1];
    var _5 = useState(""), projectId = _5[0], setProjectId = _5[1];
    var _6 = useState(""), campaignId = _6[0], setCampaignId = _6[1];
    var _7 = React.useState(""), titleDelete = _7[0], setTitleDelete = _7[1];
    var _8 = React.useState(""), subTitleDelete = _8[0], setSubTitleDelete = _8[1];
    var _9 = React.useState(""), recurrenceId = _9[0], setRecurrenceId = _9[1];
    var _10 = React.useState(""), paymentModeId = _10[0], setPaymentModeId = _10[1];
    var _11 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _11[0], setSeeToast = _11[1];
    var _12 = useState(false), showAlert = _12[0], setShowAlert = _12[1];
    var _13 = useState(""), descriptionAlert = _13[0], setDescriptionAlert = _13[1];
    var _14 = React.useState(0), panelActive = _14[0], setPanelActive = _14[1];
    var autoClose = React.useState(10000)[0];
    var autoCloseActive = React.useState(false)[0];
    var _15 = React.useState([]), rowsPaymentRecurrence = _15[0], setRowsPaymentRecurrence = _15[1];
    var _16 = React.useState([]), rowsAccountType = _16[0], setRowsAccountType = _16[1];
    var _17 = React.useState([]), rowsPlans = _17[0], setRowsPlans = _17[1];
    var _18 = React.useState([]), rowsFlags = _18[0], setRowsFlags = _18[1];
    var _19 = React.useState(), uploadedImage = _19[0], setUploadedImage = _19[1];
    var _20 = React.useState(true), showUploadButton = _20[0], setShowUploadButton = _20[1];
    var _21 = React.useState(""), imgProject = _21[0], setImgProject = _21[1];
    var _22 = React.useState(false), openDrawerPaymentR = _22[0], setOpenDrawerPaymentR = _22[1];
    var _23 = React.useState(false), openDrawerPaymentM = _23[0], setOpenDrawerPaymentM = _23[1];
    var _24 = GetInsurancesTypes(trigger, enable, page, limit, clientId), responseInsuranceType = _24.responseInsuranceType, errorInsuranceType = _24.errorInsuranceType, loadingInsuranceType = _24.loadingInsuranceType;
    var _25 = GetProjectOne(triggerDetails, idProduct), responseOneProject = _25.responseOneProject, errorOneProject = _25.errorOneProject, loadingOneProject = _25.loadingOneProject;
    var _26 = GetCampaignOne(triggerCampaign, campaignId), responseGetOneCampaign = _26.responseGetOneCampaign, errorGetOneCampaign = _26.errorGetOneCampaign, loadingGetOneCampaign = _26.loadingGetOneCampaign;
    var _27 = GetCurrencies(trigger, enable, orderBy, orderDir, page, limit), responseCurrencies = _27.responseCurrencies, errorCurrencies = _27.errorCurrencies, loadingCurrencies = _27.loadingCurrencies;
    var _28 = GetActionFlags(trigger, enable, page, limit, projectId ? projectId : idProduct || ""), responsePageActionFlags = _28.responsePageActionFlags, errorPageActionFlags = _28.errorPageActionFlags, loadingPageActionFlags = _28.loadingPageActionFlags;
    var _29 = PostActionFlags(triggerActionF, projectId ? projectId : idProduct || ""), responsePostActionFlags = _29.responsePostActionFlags, errorPostActionFlags = _29.errorPostActionFlags, loadingPostActionFlags = _29.loadingPostActionFlags;
    var _30 = GetCatalogPaymentMode(trigger, enable, page, limit, clientId), responseGetCatalogPaymentMode = _30.responseGetCatalogPaymentMode, errorGetCatalogPaymentMode = _30.errorGetCatalogPaymentMode, loadingGetCatalogPaymentMode = _30.loadingGetCatalogPaymentMode;
    var _31 = useGetPlansAll(triggerPlans, clientId, projectId || idProduct), responsePlans = _31.responsePlans, errorPlans = _31.errorPlans, loadingPlans = _31.loadingPlans;
    var _32 = GetCatalogAccountType(trigger, enable, page, limit, clientId), responseGetCatalogAccountType = _32.responseGetCatalogAccountType, errorGetCatalogAccountType = _32.errorGetCatalogAccountType, loadingGetCatalogAccountType = _32.loadingGetCatalogAccountType;
    var _33 = useSelector(function (state) {
        var _a;
        return ({
            responseSponsor: (_a = state.Sponsor.responseSponsor) === null || _a === void 0 ? void 0 : _a.data,
            errorSponsor: state.Sponsor.errorSponsor,
            loadingSponsor: state.Sponsor.loadingSponsor,
        });
    }), responseSponsor = _33.responseSponsor, errorSponsor = _33.errorSponsor, loadingSponsor = _33.loadingSponsor;
    var _34 = useSelector(function (state) { return ({
        responseProjectPost: state.Project.responseProjectPost,
        errorProjectPost: state.Project.errorProjectPost,
        loadingProjectPost: state.Project.loadingProjectPost,
    }); }), responseProjectPost = _34.responseProjectPost, errorProjectPost = _34.errorProjectPost, loadingProjectPost = _34.loadingProjectPost;
    var _35 = useSelector(function (state) {
        var _a;
        return ({
            responseProjectPatch: (_a = state.Project.responseProjectPatch) === null || _a === void 0 ? void 0 : _a.data,
            errorProjectPatch: state.Project.errorProjectPatch,
            loadingProjectPatch: state.Project.loadingProjectPatch,
        });
    }), responseProjectPatch = _35.responseProjectPatch, errorProjectPatch = _35.errorProjectPatch, loadingProjectPatch = _35.loadingProjectPatch;
    var _36 = useSelector(function (state) { return ({
        responseCampaignPost: state.Campaign.responseCampaignPost,
        errorPostCampaign: state.Campaign.errorPostCampaign,
        loadingPostCampaign: state.Campaign.loadingPostCampaign,
    }); }), responseCampaignPost = _36.responseCampaignPost, errorPostCampaign = _36.errorPostCampaign, loadingPostCampaign = _36.loadingPostCampaign;
    var _37 = useSelector(function (state) {
        var _a;
        return ({
            responseCampaignPatch: (_a = state.Campaign.responseCampaignPatch) === null || _a === void 0 ? void 0 : _a.data,
            errorCampaignPatch: state.Campaign.errorCampaignPatch,
            loadingCampaignPatch: state.Campaign.loadingCampaignPatch,
        });
    }), responseCampaignPatch = _37.responseCampaignPatch, errorCampaignPatch = _37.errorCampaignPatch, loadingCampaignPatch = _37.loadingCampaignPatch;
    var _38 = useSelector(function (state) { return ({
        responseCampaignProjectPost: state.CampaignProject.responseCampaignProjectPost,
        errorPostCampaignProject: state.CampaignProject.errorPostCampaignProject,
        loadingPostCampaignProject: state.CampaignProject.loadingPostCampaignProject,
    }); }), responseCampaignProjectPost = _38.responseCampaignProjectPost, errorPostCampaignProject = _38.errorPostCampaignProject, loadingPostCampaignProject = _38.loadingPostCampaignProject;
    var _39 = useSelector(function (state) { return ({
        responsePostPaymentMode: state.PaymentMode.responsePostPaymentMode,
        errorPostPaymentMode: state.PaymentMode.errorPostPaymentMode,
        loadingPostPaymentMode: state.PaymentMode.loadingPostPaymentMode,
    }); }), responsePostPaymentMode = _39.responsePostPaymentMode, errorPostPaymentMode = _39.errorPostPaymentMode, loadingPostPaymentMode = _39.loadingPostPaymentMode;
    var permissions = {
        create: true,
        read: true,
        update: true,
        delete: true,
    };
    var _40 = useSelector(function (state) { return ({
        responseAccountTypePost: state.AccountType.responseAccountTypePost,
        errorAccountTypePost: state.AccountType.errorAccountTypePost,
        loadingAccountTypePost: state.AccountType.loadingAccountTypePost,
    }); }), responseAccountTypePost = _40.responseAccountTypePost, errorAccountTypePost = _40.errorAccountTypePost, loadingAccountTypePost = _40.loadingAccountTypePost;
    var _41 = useSelector(function (state) {
        var _a;
        return ({
            responseAccountType: (_a = state.AccountType.responseAccountType) === null || _a === void 0 ? void 0 : _a.data,
            errorAccountType: state.AccountType.errorAccountType,
            loadingAccountType: state.AccountType.loadingAccountType,
        });
    }), responseAccountType = _41.responseAccountType, errorAccountType = _41.errorAccountType, loadingAccountType = _41.loadingAccountType;
    var _42 = useSelector(function (state) {
        var _a;
        return ({
            responsePaymentMode: (_a = state.PaymentMode.responsePaymentMode) === null || _a === void 0 ? void 0 : _a.data,
            errorPaymentMode: state.PaymentMode.errorPaymentMode,
            loadingPaymentMode: state.PaymentMode.loadingPaymentMode,
        });
    }), responsePaymentMode = _42.responsePaymentMode, errorPaymentMode = _42.errorPaymentMode, loadingPaymentMode = _42.loadingPaymentMode;
    var _43 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
    }); }), responseDeleteEntity = _43.responseDeleteEntity, errorDeleteEntity = _43.errorDeleteEntity, loadingDeleteEntity = _43.loadingDeleteEntity;
    var _44 = useSelector(function (state) { return ({
        responsePutAvatar: state.Avatar.responsePutAvatar,
        errorPutAvatar: state.Avatar.errorPutAvatar,
        loadingPutAvatar: state.Avatar.loadingPutAvatar,
    }); }), responsePutAvatar = _44.responsePutAvatar, errorPutAvatar = _44.errorPutAvatar, loadingPutAvatar = _44.loadingPutAvatar;
    useEffect(function () {
        setTrigger(true);
        dispatch(sponsor({ enable: enable, page: page, limit: limit, clientId: clientId }));
        dispatch(paymentModeClearData());
        dispatch(accountTypeClearData());
    }, []);
    useEffect(function () {
        if (idProduct && isEdit !== "true") {
            setDisableCampaign(false);
            setDisablePaymentMode(false);
            setDisableRecurrence(false);
            setDisablePlans(false);
            setDisableFlags(false);
            setActivateEditProduct(false);
            setActivateEditCampaign(false);
            setShowButtonsActions(false);
            setShowButtonAddCampaign(false);
            setShowAddButtonRecurrence(false);
            setShowAddButtonPaymentMode(false);
            setShowAddButtonPlans(false);
            setIsUpdate(false);
            setTriggerDetails(true);
            callDispatchPaymentMode();
            callDispatchAccountType();
            setTriggerPlans(true);
            setShowUploadButton(false);
        }
        if (idProduct && isEdit === "true") {
            setDisableCampaign(false);
            setDisablePaymentMode(false);
            setDisableRecurrence(false);
            setDisablePlans(false);
            setDisableFlags(false);
            setActivateEditProduct(false);
            setActivateEditCampaign(false);
            setShowAddButtonRecurrence(true);
            setShowAddButtonPaymentMode(true);
            setTriggerDetails(true);
            setShowCancelButton(true);
            callDispatchPaymentMode();
            callDispatchAccountType();
            setIsUpdate(true);
            setShowAddButtonPlans(true);
            setTriggerPlans(true);
        }
        if (idProduct && isEdit === "true" && plans === "true") {
            setPanelActive(3);
        }
    }, [idProduct, isEdit, plans]);
    useEffect(function () {
        if (errorGetCatalogPaymentMode) {
            showErrorToast(errorGetCatalogPaymentMode, setSeeToast, t);
        }
    }, [errorGetCatalogPaymentMode]);
    useEffect(function () {
        if (errorOneProject) {
            showErrorToast(errorOneProject, setSeeToast, t);
        }
    }, [errorOneProject]);
    useEffect(function () {
        if (errorPutAvatar) {
            showErrorToast(errorPutAvatar, setSeeToast, t);
        }
    }, [errorPutAvatar]);
    useEffect(function () {
        if (errorGetOneCampaign) {
            showErrorToast(errorGetOneCampaign, setSeeToast, t);
            dispatch(campaignOneClearData());
        }
    }, [errorGetOneCampaign]);
    useEffect(function () {
        if (errorGetOneCampaign) {
            showErrorToast(errorGetOneCampaign, setSeeToast, t);
            dispatch(campaignOneClearData());
        }
    }, [errorGetOneCampaign]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorPostPaymentMode) {
            showErrorToast(errorPostPaymentMode, setSeeToast, t);
        }
    }, [errorPostPaymentMode]);
    useEffect(function () {
        if (errorGetCatalogAccountType) {
            showErrorToast(errorGetCatalogAccountType, setSeeToast, t);
        }
    }, [errorGetCatalogAccountType]);
    useEffect(function () {
        if (errorSponsor) {
            showErrorToast(errorSponsor, setSeeToast, t);
        }
    }, [errorSponsor]);
    useEffect(function () {
        if (errorCurrencies) {
            showErrorToast(errorCurrencies, setSeeToast, t);
        }
    }, [errorCurrencies]);
    useEffect(function () {
        if (errorPostCampaignProject) {
            showErrorToast(errorPostCampaignProject, setSeeToast, t);
        }
    }, [errorPostCampaignProject]);
    useEffect(function () {
        if (errorCampaignPatch) {
            showErrorToast(errorCampaignPatch, setSeeToast, t);
        }
    }, [errorCampaignPatch]);
    useEffect(function () {
        if (errorInsuranceType) {
            showErrorToast(errorInsuranceType, setSeeToast, t);
        }
    }, [errorInsuranceType]);
    useEffect(function () {
        if (errorProjectPost) {
            showErrorToast(errorProjectPost, setSeeToast, t);
        }
    }, [errorProjectPost]);
    useEffect(function () {
        if (errorAccountTypePost) {
            showErrorToast(errorAccountTypePost, setSeeToast, t);
        }
    }, [errorAccountTypePost]);
    useEffect(function () {
        if (errorAccountType) {
            showErrorToast(errorAccountType, setSeeToast, t);
        }
    }, [errorAccountType]);
    useEffect(function () {
        if (errorPostCampaign) {
            showErrorToast(errorPostCampaign, setSeeToast, t);
        }
    }, [errorPostCampaign]);
    useEffect(function () {
        if ((responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.length) > 0) {
            var newInsurancesTypeList = responseInsuranceType.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setInsuranceTypeList(newInsurancesTypeList);
        }
    }, [responseInsuranceType]);
    useEffect(function () {
        if ((responseCurrencies === null || responseCurrencies === void 0 ? void 0 : responseCurrencies.length) > 0) {
            var catalogType = responseCurrencies.map(function (item) { return ({
                id: item.id,
                name: item.name,
                value: item.id,
            }); });
            setCurrencyList(catalogType);
        }
    }, [responseCurrencies]);
    useEffect(function () {
        if ((responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.length) > 0) {
            var newSponsorList = responseSponsor.map(function (item) { return ({
                id: item.id,
                name: item.name,
                value: item.id,
            }); });
            setSponsorList(newSponsorList);
        }
    }, [responseSponsor]);
    useEffect(function () {
        if ((responseGetCatalogPaymentMode === null || responseGetCatalogPaymentMode === void 0 ? void 0 : responseGetCatalogPaymentMode.length) > 0) {
            var paymentRecurrence = responseGetCatalogPaymentMode.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setPaymentModeList(paymentRecurrence);
            dispatch(getCatalogPaymentModeClearData());
        }
    }, [responseGetCatalogPaymentMode]);
    useEffect(function () {
        if ((responseGetCatalogAccountType === null || responseGetCatalogAccountType === void 0 ? void 0 : responseGetCatalogAccountType.length) > 0) {
            var accountType_1 = responseGetCatalogAccountType.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setAccountTypeList(accountType_1);
            dispatch(getCatalogAccountTypeClearData());
        }
    }, [responseGetCatalogAccountType, responseAccountType]);
    useEffect(function () {
        if (responseProjectPost && (responseProjectPost === null || responseProjectPost === void 0 ? void 0 : responseProjectPost.data)) {
            setShowAlert(true);
            setDescriptionAlert("Para continuar, ahora cree una campaña");
            setDisableCampaign(false);
            showToastSuccessMessage("Producto creado con éxito.", typeAlert.success, setSeeToast);
            if (uploadedImage) {
                dispatch(putAvatar("Project", responseProjectPost.data.id, uploadedImage));
                setUploadedImage(null);
            }
            setProjectId(responseProjectPost.data.id);
            setTriggerPlans(true);
            dispatch(projectPostClearData());
        }
    }, [responseProjectPost]);
    useEffect(function () {
        if (projectId) {
            setTriggerActionF(true);
        }
    }, [projectId]);
    useEffect(function () {
        if (responsePutAvatar && (responsePutAvatar === null || responsePutAvatar === void 0 ? void 0 : responsePutAvatar.url)) {
            showToastSuccessMessage("Producto actualizado con éxito.", typeAlert.success, setSeeToast);
            dispatch(clearDataPutAvatar());
        }
    }, [responsePutAvatar]);
    useEffect(function () {
        var _a;
        if (responseProjectPatch) {
            showToastSuccessMessage("Producto actualizado con éxito.", typeAlert.success, setSeeToast);
            dispatch(projectPatchClearData());
            if (uploadedImage) {
                dispatch(putAvatar("Project", (_a = responseProjectPatch === null || responseProjectPatch === void 0 ? void 0 : responseProjectPatch.data) === null || _a === void 0 ? void 0 : _a.id, uploadedImage));
                setUploadedImage(null);
            }
        }
    }, [responseProjectPatch]);
    useEffect(function () {
        var _a, _b;
        if (responseCampaignPost && (responseCampaignPost === null || responseCampaignPost === void 0 ? void 0 : responseCampaignPost.data)) {
            setShowAlert(true);
            setActivateEditProduct(false);
            setActivateEditCampaign(false);
            setDescriptionAlert("Para continuar, ahora Agregue una recurrencia de pago");
            showToastSuccessMessage("Campaña creada con éxito.", typeAlert.success, setSeeToast);
            setDisableRecurrence(false);
            setPanelActive(1);
            var newCampaignProjectData = {
                status: 1,
                projectId: projectId ? projectId : idProduct,
                campaignId: (_a = responseCampaignPost === null || responseCampaignPost === void 0 ? void 0 : responseCampaignPost.data) === null || _a === void 0 ? void 0 : _a.id,
            };
            setCampaignId((_b = responseCampaignPost === null || responseCampaignPost === void 0 ? void 0 : responseCampaignPost.data) === null || _b === void 0 ? void 0 : _b.id);
            dispatch(campaignProjectPost(newCampaignProjectData));
            dispatch(campaignProjectPostClearData());
            dispatch(campaignPostClearData());
        }
    }, [responseCampaignPost]);
    useEffect(function () {
        if (responseCampaignPatch) {
            showToastSuccessMessage("Campaña actualizada con éxito.", typeAlert.success, setSeeToast);
            dispatch(campaignPatchClearData());
        }
    }, [responseCampaignPatch]);
    useEffect(function () {
        if (responsePostPaymentMode && (responsePostPaymentMode === null || responsePostPaymentMode === void 0 ? void 0 : responsePostPaymentMode.data)) {
            callDispatchPaymentMode();
            setShowAlert(true);
            setDescriptionAlert("Para continuar, ahora Agregue un modo de pago");
            showToastSuccessMessage("Recurrencia de pago agregada con éxito.", typeAlert.success, setSeeToast);
            setOpenDrawerPaymentR(false);
            setDisablePaymentMode(false);
            dispatch(postPaymentModeClearData());
        }
    }, [responsePostPaymentMode]);
    useEffect(function () {
        if (responseAccountTypePost && (responseAccountTypePost === null || responseAccountTypePost === void 0 ? void 0 : responseAccountTypePost.data)) {
            callDispatchAccountType();
            setShowAddButtonPlans(true);
            setShowAlert(true);
            setDescriptionAlert("Para continuar, ahora Agregue los planes");
            showToastSuccessMessage("Modo de pago agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenDrawerPaymentM(false);
            setDisablePlans(false);
            dispatch(accountTypePostClearData());
        }
    }, [responseAccountTypePost]);
    useEffect(function () {
        if (Array.isArray(responsePaymentMode)) {
            setPaymentRecurrenceStorybook(responsePaymentMode);
            if ((responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.length) === 0) {
                setDisableRecurrence(false);
                setShowAddButtonRecurrence(true);
                setShowAddButtonPaymentMode(true);
            }
            if ((responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.length) > 0) {
                var idsToRemove_1 = responsePaymentMode.map(function (item) { return item.catalogPaymentMode.id; });
                var updatedList = paymentModeList.filter(function (item) { return !idsToRemove_1.includes(item.id); });
                setPaymentModeList(updatedList);
            }
        }
    }, [responsePaymentMode]);
    useEffect(function () {
        if (Array.isArray(responseAccountType)) {
            setAccountTypeStorybook(responseAccountType);
            if ((responseAccountType === null || responseAccountType === void 0 ? void 0 : responseAccountType.length) === 0) {
                setShowAddButtonPaymentMode(true);
            }
            if ((responseAccountType === null || responseAccountType === void 0 ? void 0 : responseAccountType.length) > 0) {
                var idsToRemove_2 = responseAccountType.map(function (item) { return item.catalogAccountType.id; });
                var updatedList = accountTypeList.filter(function (item) { return !idsToRemove_2.includes(item.id); });
                setAccountTypeList(updatedList);
            }
        }
    }, [responseAccountType]);
    useEffect(function () {
        if (Array.isArray(responsePlans)) {
            setPlansStorybook(responsePlans);
        }
        if ((responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.length) > 0) {
            setDisableFlags(false);
        }
        if ((responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.length) > 0) {
            setDisableFlags(false);
        }
    }, [responsePlans]);
    useEffect(function () {
        if (Array.isArray(responsePageActionFlags)) {
            setActionFlagsStorybook(responsePageActionFlags);
        }
    }, [responsePageActionFlags]);
    useEffect(function () {
        var _a, _b, _c;
        if (responseOneProject) {
            setDataProductCreation({
                IdSponsor: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.sponsorId,
                IdTypeInsurance: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.projectTypeId,
                Description: responseOneProject.description,
                Code: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.code,
                IdCurrency: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.currencyId,
                CertifyNumber: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.certId,
                QuotesNumber: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.countPolicy,
                PolicyNumber: responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.countQuote,
                isIframe: (_a = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.metadata) === null || _a === void 0 ? void 0 : _a.iframe,
                IframeUrl: (_b = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.metadata) === null || _b === void 0 ? void 0 : _b.iframeUrl,
            });
            setImgProject(responseOneProject.logoUrl);
            if (responseOneProject.campaign.length > 0) {
                setCampaignId(responseOneProject.campaign[0].id);
                setTriggerCampaign(true);
            }
            dispatch(projectOneClearData());
            if (((_c = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.campaign) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                setIsUpdate(false);
                setActivateEditCampaign(true);
                setShowButtonAddCampaign(true);
                setShowAddButtonPaymentMode(true);
                setShowAddButtonRecurrence(true);
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        if (responseGetOneCampaign) {
            setDataCampaignCreation({
                CampaignName: responseGetOneCampaign.name,
                CodeCampaign: responseGetOneCampaign.code,
                StartDateCampaign: formattedDateYYMMDD(responseGetOneCampaign.startDate),
                EndDateCampaign: formattedDateYYMMDD(responseGetOneCampaign.endDate),
            });
            dispatch(campaignOneClearData());
        }
    }, [responseGetOneCampaign]);
    useEffect(function () {
        if (responseDeleteEntity) {
            callDispatchPaymentMode();
            callDispatchAccountType();
        }
        dispatch(deleteEntityClearData());
    }, [responseDeleteEntity]);
    var callDispatchPaymentMode = function () {
        if (projectId || idProduct) {
            dispatch(paymentModeAction({
                enable: enable,
                page: page,
                limit: limit,
                projectId: projectId || idProduct,
                deleted: false,
            }));
        }
    };
    var callDispatchAccountType = function () {
        if (projectId || idProduct) {
            dispatch(accountType({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
                projectId: projectId || idProduct,
                deleted: false,
            }));
        }
    };
    var setPaymentRecurrenceStorybook = function (responsePaymentMode) {
        var recurrenceRows = responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.map(function (item) { return ({
            id: item.id,
            code: item.catalogPaymentMode.code,
            description: item.catalogPaymentMode.description,
        }); });
        setRowsPaymentRecurrence(recurrenceRows);
        dispatch(paymentModeClearData());
    };
    var setAccountTypeStorybook = function (responseAccountType) {
        var accountTypeRows = responseAccountType === null || responseAccountType === void 0 ? void 0 : responseAccountType.map(function (item) { return ({
            id: item.id,
            code: item.catalogAccountType.code,
            description: item.catalogAccountType.description,
        }); });
        setRowsAccountType(accountTypeRows);
        dispatch(accountTypeClearData());
    };
    var setPlansStorybook = function (responsePlans) {
        var plansRows = responsePlans.map(function (item) {
            var coverTypeDescriptions = item.coverTypes
                .map(function (type) { return type.description; })
                .join(", ");
            return {
                id: item.id,
                code: item.code,
                name: item.name,
                coverType: coverTypeDescriptions,
            };
        });
        setRowsPlans(plansRows);
        dispatch(plansClearData());
    };
    var setActionFlagsStorybook = function (responsePageActionFlags) {
        var actionFlagsRows = responsePageActionFlags.map(function (item) {
            return {
                id: item.id,
                value: item.value === "true" ? "Activo" : "Inactivo",
                name: item.name,
            };
        });
        setRowsFlags(actionFlagsRows);
        dispatch(plansClearData());
    };
    var handleSubmitProduct = function (dataProductCreation, fileImg) {
        if (isUpdate) {
            var projectData = {
                code: dataProductCreation.Code,
                description: dataProductCreation.Description,
                certId: dataProductCreation.CertifyNumber,
                countQuote: dataProductCreation.QuotesNumber,
                countPolicy: dataProductCreation.PolicyNumber,
                sponsorId: dataProductCreation.IdSponsor,
                projectTypeId: dataProductCreation.IdTypeInsurance,
                currencyId: dataProductCreation.IdCurrency,
                metadata: {
                    iframe: dataProductCreation.isIframe,
                    iframeUrl: dataProductCreation.IframeUrl,
                },
            };
            dispatch(projectPatch(projectData, projectId ? projectId : idProduct));
            setUploadedImage(fileImg);
        }
        else {
            var projectData = {
                code: dataProductCreation.Code,
                description: dataProductCreation.Description,
                certId: dataProductCreation.CertifyNumber,
                countQuote: parseInt(dataProductCreation.QuotesNumber),
                countPolicy: parseInt(dataProductCreation.PolicyNumber),
                sponsorId: dataProductCreation.IdSponsor,
                projectTypeId: dataProductCreation.IdTypeInsurance,
                currencyId: dataProductCreation.IdCurrency,
                metadata: {
                    iframe: dataProductCreation.isIframe,
                    iframeUrl: dataProductCreation.IframeUrl,
                },
            };
            setDataProductCreation(dataProductCreation);
            dispatch(projectPost(projectData));
            setUploadedImage(fileImg);
        }
    };
    var handleSubmitCampaign = function (dataCampaign) {
        if (isUpdate) {
            var newCampaignData = {
                name: dataCampaign.CampaignName,
                code: dataCampaign.CodeCampaign,
                startDate: dataCampaign.StartDateCampaign,
                endDate: dataCampaign.EndDateCampaign,
            };
            dispatch(campaignPatch(newCampaignData, campaignId));
        }
        else {
            var newCampaignData = {
                name: dataCampaign.CampaignName,
                code: dataCampaign.CodeCampaign,
                startDate: dataCampaign.StartDateCampaign,
                endDate: dataCampaign.EndDateCampaign,
            };
            setDataCampaignCreation(dataCampaign);
            dispatch(campaignPost(newCampaignData));
        }
    };
    var handleSubmitPaymentRecurrence = function (PaymentRecurrence) {
        var paymentRecurrenceData = {
            projectId: projectId ? projectId : idProduct,
            catalogPaymentModeId: PaymentRecurrence.paymentRecurrence
                ? PaymentRecurrence.paymentRecurrence
                : "",
        };
        dispatch(postPaymentMode(paymentRecurrenceData));
        dispatch(postPaymentModeClearData());
    };
    var handleSubmitAccountType = function (PaymentModeId) {
        var paymentModeData = {
            projectId: projectId ? projectId : idProduct,
            catalogAccountTypeId: PaymentModeId.paymentMode
                ? PaymentModeId.paymentMode
                : "",
        };
        dispatch(accountTypePost(paymentModeData));
        dispatch(accountTypePostClearData());
    };
    var onClickBack = function () {
        navigate(-1);
    };
    var onClickAddPlans = function () {
        var id = projectId ? projectId : idProduct;
        navigate("/plan-creation/".concat(id));
    };
    var clickContextMenuPlans = function (item) {
        var id = projectId ? projectId : idProduct;
        var idPlan = item.id;
        navigate("/plan-creation/".concat(id, "/").concat(idPlan));
    };
    var clickContextMenuRecurrence = function (item) {
        var _a;
        setOpenModal(true);
        setTitleDelete("recurrencia de pago");
        setSubTitleDelete("la recurrencia de pago ".concat((_a = item.description) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
        setRecurrenceId(item.id ? item.id : "");
    };
    var deleteRecurrence = function () {
        setOpenModal(false);
        dispatch(deleteEntity({
            id: recurrenceId,
            entity: "PaymentModeProjectEntity",
            idUser: lsLogin.getUserLoginStored().userId,
            body: {
                force: true,
            },
        }));
    };
    var clickContextMenuPaymentMode = function (item) {
        var _a;
        setOpenModal(true);
        setTitleDelete("modo de pago");
        setSubTitleDelete("el modo de pago ".concat((_a = item.description) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
        setPaymentModeId(item.id ? item.id : "");
    };
    var deletePaymentMode = function () {
        setOpenModal(false);
        dispatch(deleteEntity({
            id: paymentModeId,
            entity: "AccountTypeProjectEntity",
            idUser: lsLogin.getUserLoginStored().userId,
            body: {
                force: true,
            },
        }));
    };
    var columnsRecurrence = ColumnsPaymentRecurrence(clickContextMenuRecurrence);
    var columnsPaymentMode = ColumnsPaymentMode(clickContextMenuPaymentMode);
    var columnsPlans = ColumnsPlans(clickContextMenuPlans);
    var ColumnsFlags = ColumnsActionsFlags();
    return (_jsxs(_Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(LoadingAFY, { loading: loadingInsuranceType ||
                    loadingSponsor ||
                    loadingCurrencies ||
                    loadingProjectPost ||
                    loadingPostCampaign ||
                    loadingPostPaymentMode ||
                    loadingAccountTypePost ||
                    loadingOneProject ||
                    loadingProjectPatch ||
                    loadingCampaignPatch ||
                    loadingDeleteEntity, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: loadingProjectPatch || loadingCampaignPatch
                    ? "Actualizando"
                    : "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(ProductCreationView, { permissions: permissions, disableCampaign: disableCampaign, disableRecurrence: disableRecurrence, disablePaymentMode: disablePaymentMode, disablePlans: disablePlans, disableFlags: disableFlags, insuranceTypeList: insuranceTypeList, dataProductCreation: dataProductCreation, sponsorList: sponsorList, handleSubmitProduct: handleSubmitProduct, currencyList: currencyList, showAlert: showAlert, descriptionAlert: descriptionAlert, dataCampaignCreation: dataCampaignCreation, setDescriptionAlert: setDescriptionAlert, handleSubmitCampaign: handleSubmitCampaign, panelActive: panelActive, autoClose: autoClose, autoCloseActive: autoCloseActive, setShowAlert: setShowAlert, paymentModeList: paymentModeList, accountTypeList: accountTypeList, handleSubmitPaymentRecurrence: handleSubmitPaymentRecurrence, handleSubmitAccountType: handleSubmitAccountType, rowsPaymentRecurrence: rowsPaymentRecurrence, rowsAccountType: rowsAccountType, rowsPlans: rowsPlans, activateEditProduct: activateEditProduct, activateEditCampaign: activateEditCampaign, showButtonsActions: showButtonsActions, onClickBack: onClickBack, showButtonAddRecurrence: showAddButtonRecurrence, showButtonAddPaymentMode: showAddButtonPaymentMode, showAddButtonPlans: showAddButtonPlans, idProduct: idProduct, isEdit: isEdit, showCancelButton: showCancelButton, setIsUpdate: setIsUpdate, setShowCancelButton: setShowCancelButton, showButtonAddCampaign: showButtonAddCampaign, onClickAddPlans: onClickAddPlans, columnsRecurrence: columnsRecurrence, columnsPaymentMode: columnsPaymentMode, openModal: openModal, setOpenModal: setOpenModal, titleDelete: titleDelete, subTitleDelete: subTitleDelete, deleteRecurrence: deleteRecurrence, deletePaymentMode: deletePaymentMode, columnsPlans: columnsPlans, ColumnsFlags: ColumnsFlags, rowsFlags: rowsFlags, showUploadButton: showUploadButton, imgProject: imgProject, openDrawerPaymentR: openDrawerPaymentR, setOpenDrawerPaymentR: setOpenDrawerPaymentR, openDrawerPaymentM: openDrawerPaymentM, setOpenDrawerPaymentM: setOpenDrawerPaymentM })] }));
};
